import { Reveal } from "./motion";

const promises = [
  {
    title: "Fixed, posted rates",
    body: "You see our rate before you book. The price in your signed work order is the price you pay.",
  },
  {
    title: "Sign before we lift",
    body: "You review and e-sign your work order on your own device when you book, and we email you a copy. Nothing starts until it's signed.",
  },
  {
    title: "Know your crew",
    body: "Our crew lead introduces the team when they arrive. Ask anytime, and we'll tell you who's on your job.",
  },
  {
    title: "Honest time tracking",
    body: "Your crew lead texts you when the clock starts, stops for breaks, and ends. Breaks longer than 10 minutes are not billed.",
  },
  {
    title: "Same-day invoice",
    body: "You receive an itemized invoice the same day your job is completed, showing start and stop times and every charge.",
  },
  {
    title: "Your truck, your keys, your belongings",
    body: "Because we are labor-only, your belongings never leave your control. No one can hold your items for payment.",
  },
];

export const OurPromise = () => (
  <section
    id="our-promise"
    data-testid="our-promise-section"
    className="relative z-10 bg-[#1C1C1C] py-20 sm:py-28 border-b border-white/5"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl mb-12">
        <p className="text-xs tracking-[0.3em] uppercase text-[#FF4500] font-bold mb-4">
          Our Promise
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl">
          No Surprises
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
        {promises.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.06}>
            <div
              data-testid={`promise-card-${i + 1}`}
              className="h-full border border-[#3d3d3d] bg-[#303030] p-8"
            >
              <h3 className="font-display font-bold uppercase tracking-tight text-lg text-white leading-snug">
                {p.title}
              </h3>
              <p className="mt-4 text-neutral-200 text-base leading-relaxed">
                {p.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
